import React from 'react';

interface CreateIntegrationButtonProps {
  onClick?: (_event: React.MouseEvent<HTMLDivElement>) => void;
}

export const CreateIntegrationButton: React.FC<CreateIntegrationButtonProps> = ({ onClick }) => {
  return (
    <div
      className="create-integration-button flex flex-column align-items-center justify-content-center p-4 cursor-pointer"
      onClick={onClick}
      style={{
        border: '1px dashed #ccc',
        borderRadius: '12px',
        width: '100%',
        height: '150px',
        transition: 'all 0.3s',
      }}
      onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#f8f9fa')}
      onMouseOut={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
    >
      <div
        className="plus-circle flex align-items-center justify-content-center mb-2"
        style={{
          width: '40px',
          height: '40px',
          borderRadius: '50%',
          border: '1px solid #4F46E5',
          color: '#4F46E5',
        }}
      >
        <i className="pi pi-plus"></i>
      </div>
      <div className="button-text text-color-secondary">Create</div>
    </div>
  );
};
